/**
 * FeatureNames
 * An enum of all feature flags used throughout the platform
 * TIP - right click each key in the enum and select "Find All References" to see where this is used
 */
export enum FeatureNames {
    // // // //
    // App Features
    enableDataDownloads = "enable-data-downloads",

    // // // //
    // API Tools
    enableApiKeys = "enable-api-keys",

    // // // //
    // MCP Tools
    enableMcpTools = "enable-mcp-tools",

    // // // //
    // Admin Tools
    enableAdminTools = "enable-admin-tools",

    // // // //
    // Experimental Features
    enableExperimentalFeatures = "enable-experimental-features",
    enableChartsPages = "enable-charts-pages",
}
